import { Tooltip, theme } from '@aloft/toolkit-sui';

export const WarningTooltipIcon = ({ label }: { label: string }) => (
  <Tooltip label={label}>
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path
        d="M6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1ZM5.58105 8.07031V8.90332H6.41504V8.07031H5.58105ZM5.58105 3.07031V6.82031H6.41504V3.07031H5.58105Z"
        fill={theme.colors.statusWarning}
      />
    </svg>
  </Tooltip>
);
